import { deepOrange } from '@material-ui/core/colors';

export const styles = ({
    button: {
        color: deepOrange[500]
    }
});
